export const certifiedAccolade = (coach) => coach.user_accolades?.find(userAccolade => userAccolade.accolade?.name === 'Certified')

const BADGES = [
  { key: 'certified', accoladeName: 'Certified', matches: name => name === 'Certified' },
  { key: 'top50', accoladeName: 'Top 50', matches: name => name === 'Top 50' || /^\d{4} Top 50$/.test(name) },
  { key: 'masterTop50', accoladeName: 'Master Top 50', matches: name => name === 'Master Top 50' },
]

export const accoladeBadges = (userAccolades = []) => BADGES.map(({ matches, ...badge }) => ({
  ...badge,
  earned: userAccolades.filter(userAccolade => matches(userAccolade.accolade?.name || '')),
}))
